import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mesCountLabel'
})
export class MesCountLabelPipe implements PipeTransform {
    transform(count: number): string {
        if (count == null || count === undefined) {
            return '';
        }

        return count == 1 ? 'mês' : 'meses';
    }
}
